import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

export function requiredValidator(label: string, translate: TranslateService): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value || control.value === '') {
      /*  */
      let stringMsg = '';
      translate
        .get(['error.validation.required.part1', label, 'error.validation.required.part2'])
        .subscribe((translations) => {
          stringMsg =
            translations['error.validation.required.part1'] +
            ' ' +
            translations[label] +
            ' ' +
            translations['error.validation.required.part2'];
        });
      return { invalidRequired: { value: control.value, msg: stringMsg } };
    }

    return null;
  };
}
